const propMappings = {
  lossDate: ['lossDate'],
  lineOfBusiness: ['claim_type'],
  lossScenario: ['lossCause'],
  secLossScenario: ['secLossScenario'],
  digitalFNOLStatus: ['digitalFNOLStatus'],
  description: ['description'],
  lossLocation: ['lossLocationAddress'],
  officials: ['officials'],
  contact: ['contact'],
  notes: ['notes'],
  injuryIncident: ['injuredInjuries'],
  dwellingCode: ['dwellingCode'],
  damageFromStormOrWeather: ['damageFromStormOrWeather'],
  occupied: ['locationOccupied'],
  anyoneHome: ['anyoneHome'],
  canResideHome: ['canResideHome'],
  contactCleaningDamages: ['contactCleaningDamages'],
  emergencyServicesRequired: ['requireEmergencyServices'],

  // fire damage details mappings
  'fireDamageDetails.fireStartLocation': ['fireStartLocation'],
  'fireDamageDetails.neighboursFireDamage': ['neighboursFireDamage'],
  'fireDamageDetails.howFireStart': ['howFireStart'],
  'fireDamageDetails.whatDamageSustain': ['fireDamage', 'selectedValues'],

  // water damage details mappings
  'waterDamageDetails.describeWater': ['whatDoesTheWaterLookLike'],
  'waterDamageDetails.whereWaterFrom': ['whereWaterFrom'],

  // wind damage details mappings
  'windDamageDetails.typeDamage': ['windHailDamage', 'selectedValues'],
  'windDamageDetails.fallenTreesOnProperty': ['fallenTreesOnProperty'],
  'windDamageDetails.treesDamageProperty': ['treesDamageProperty'],

  // theft damage details mappings
  'theftDamageDetails.itemLostOrStolen': ['itemLostOrStolen'],
  'theftDamageDetails.whereItemsMissingFrom': ['stolenFrom'],
  'theftDamageDetails.lastTimeSawItem': ['lastTimeSawItem'],
  'theftDamageDetails.forcedEntryDamage': ['forcedEntryDamage'],

  // dwelling incident
  'dwellingIncident.whereDamageHome': ['whereDamageHome', 'selectedValues'],
  'dwellingIncident.indoorDamaged': ['indoorRoomsDamaged'],
  'dwellingIncident.roomDamage': ['roomDamage'],
  'dwellingIncident.exteriorDamaged': ['exteriorDamaged'],
  'dwellingIncident.exteriorDamage': ['exteriorDamage'],
  'dwellingIncident.slopesRoofAffected': ['exterior', 'roofSlopes'],
  'dwellingIncident.sidesHomeDamaged': ['exterior', 'homeSides'],
  'dwellingIncident.sectionsFenceDamaged': ['exterior', 'fenceSections'],
  'dwellingIncident.materialFence': ['exterior', 'fenceMaterial'],
  'dwellingIncident.id': ['dwellingIncidentId'],
  'dwellingIncident.temporaryId': ['dwellingIncidentTemporaryId'],

  // property contents incident
  'propertyContentsIncident.lostDamagedItems': ['lostDamagedItems'],
  'propertyContentsIncident.id': ['propertyContentsIncidentId'],
  'propertyContentsIncident.temporaryId': ['propertyContentsIncidentTemporaryId'],

  // other structure incident
  'otherStructureIncident.outbuildingDamaged_Ext': ['outbuildingDamaged_Ext'],
  'otherStructureIncident.id': ['otherStructureIncidentId'],
  'otherStructureIncident.temporaryId': ['otherStructureIncidentTemporaryId'],
};

module.exports = {
  propMappings,
};
